export default {
  dbi_metrics_creditability_title: '指标置信度',
  dbi_creditability_header: '置信度',
  dbi_creditability_info: '置信度说明',
}